import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

const PatientDiagnosisItem = ({
  index,
  diagnosis,
  isSelected,
  handleDiagnosis,
  setIsEditDiagnosis,
  setCurrentDiagnosis,
}) => {
  const [isDiagnosisHovered, setIsDiagnosisHovered] = useState(false);
  const selected = isSelected || isDiagnosisHovered;

  return (
    <div
      className="view-pdf__notes-header--note"
      onMouseEnter={() => setIsDiagnosisHovered(true)}
      onMouseLeave={() => setIsDiagnosisHovered(false)}
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: selected ? "#f5f5f5" : "#ffffff",
        wordBreak: "break-word",
      }}
    >
      {diagnosis}
      {isDiagnosisHovered && (
        <div className="view-pdf__notes-actions">
          <Tooltip title="Edit diagnosis">
            <Edit
              fontSize="small"
              className="edit-btn"
              onClick={() => {
                setIsEditDiagnosis(true);
                setCurrentDiagnosis({ index, diagnosis });
              }}
            />
          </Tooltip>
          <Tooltip title="Delete diagnosis">
            <Delete
              fontSize="small"
              className="delete-btn"
              onClick={() => handleDiagnosis(true, diagnosis, index)}
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default PatientDiagnosisItem;
